import { createAction } from 'redux-act';

export const setProfileInfo = createAction('Profile info received');
export const profileInfoReset = createAction('Reset profile info');
